module.exports = __webpack_public_path__ + "a43a86bf8b04e08e5107340bab90ec77.png";